var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.912502 3.175L2.0875 2L7.0875 7L2.0875 12L0.912502 10.825L4.72917 7L0.912502 3.175Z",
    fill: "#ECC52E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanArrow);
export default __webpack_public_path__ + "static/media/loan-arrow.7cd08ba3ffd85612d8e67159163b7d79.svg";
export { ForwardRef as ReactComponent };